import { toast } from "sonner";
import { useSettings } from "../context/SettingsContext";

export const DonateButton = ({
  size = "",
  variant = "",
  testid = "donate-nav-button",
  className = "",
}) => {
  const { settings } = useSettings();
  const url = settings?.donation_url;
  const cls = `btn ${variant} ${size} ${className}`.trim();

  if (url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={cls}
        data-testid="donate-outbound-button"
      >
        Donate
      </a>
    );
  }
  return (
    <button
      type="button"
      aria-disabled="true"
      className={`${cls} btn-dim`}
      data-testid={testid === "donate-nav-button" ? "donate-disabled-button" : testid}
      onClick={() =>
        toast(
          "Online giving opens soon. To give now, contact us at kamalamafoundation@gmail.com or (808) 631-8672.",
          { duration: 6000 },
        )
      }
    >
      Donate
    </button>
  );
};
